import { render, staticRenderFns } from "./hesapgurubu.vue?vue&type=template&id=2fbe585a"
import script from "./hesapgurubu.vue?vue&type=script&lang=js"
export * from "./hesapgurubu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports